import React from "react";
import { Box, Heading } from "grommet";
import { useNavigate, useParams } from "react-router-dom";
import { LinkPrevious } from "grommet-icons";

const BreadcrumbNavigation = ({ current, previous, current_link_name, previous_link_name,  }) => {
  const navigate = useNavigate();
  const { manager_id } = useParams();

  return (
    <Box>
      <Heading level="2" margin="none">
        <span
          style={{ cursor: "pointer" }}
          onClick={() => navigate(`/${manager_id}/manager/${previous_link_name}`)}
        >
          {previous}
        </span>
        {previous && current && " / "}
        <span
          style={{ cursor: "pointer" }}
          onClick={() => navigate(`/${manager_id}/manager/${current_link_name}`)}
        >
          {current}
        </span>
      </Heading>
    </Box>
  );
};

export default BreadcrumbNavigation;